import portaro from '../portaro';
import {remove} from 'shared/utils/array-utils.fp';
import {getErrorMessage, transferify} from 'shared/utils/data-service-utils';
import {states} from '../commons/constants/portaro.constants';

portaro.controller('TenderCtrl', ['$scope', '$timeout', 'CONTEXT_PATH', 'currentAuth', 'tenderService', 'Offer', 'Demand', 'finishedResponseInteractionService',
    function($scope, $timeout, CONTEXT_PATH, currentAuth, tenderService, Offer, Demand, finishedResponseInteractionService) {

        $scope.CONTEXT_PATH = CONTEXT_PATH;
        $scope.currentAuth = currentAuth;


        $scope.init = async function () {
            const tenderId = window.model.tenderId;
            $scope.quantitySelection = window.model.quantitySelection;
            $scope.dph = window.model.dph;

            $scope.tender = await tenderService.getById(tenderId);
            await reloadOfferingStates();

            const activeUserId = currentAuth.role.includes('ROLE_SUPPLIER') ? currentAuth.activeUser.id : null;
            $scope.demands = await Demand.query({tender: tenderId, user: activeUserId}).$promise;
            $scope.demands.forEach(demand => fillDemand(demand));

            $scope.$apply();
        };


        async function reloadOfferingStates() {
            const offeringStates = await tenderService.getOfferingStates($scope.tender, currentAuth.activeUser);
            if (offeringStates.length > 1) {
                throw new Error("Multiple offeringStates are not supported yet");
            }
            $scope.offeringStates = offeringStates;
            $scope.$apply();
        }


        function fillDemand(demand) {
            demand.offerCreation = {
                state: states.NORMAL,
                offer: {
                    demandId: demand.id,
                    quantity: demand.desiredQuantity,
                    price: null,
                    note: null,
                    currency: {
                        id: "CZK",
                        text: "Kč"
                    }
                },
                open: function() {
                    this.state = states.EDITING;
                },
                close: function() {
                    this.state = states.NORMAL;
                },
                send: async function () {
                    this.state = states.PROCESSING;
                    try {
                        const createdOffer = await Offer.save(transferify(this.offer)).$promise;
                        this.close();
                        demand.offers.push(createdOffer);
                        await reloadOfferingStates();
                    } catch (exceptionResponse) {
                        this.state = states.EDITING;
                        await finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
                    }
                    $scope.$apply();
                }
            };
            demand.removeOffer = async function (offer) {
                await Offer.remove({id: offer.id}).$promise;
                remove(offer)(demand.offers);
                await reloadOfferingStates();
                $scope.$apply();
            };
        }


        $scope.onAgreementFileSelect = async function (files) {
            try {
                await tenderService.uploadAgreement($scope.tender, currentAuth.activeUser, files[0]);
                await reloadOfferingStates();
            } catch (e) {
                alert(getErrorMessage(e));
            }
            $scope.$apply();
        };


        $scope.confirmAgreement = async function () {
            await tenderService.confirmAgreement($scope.tender, currentAuth.activeUser);
            await reloadOfferingStates();
            $scope.$apply();
        };


    }]);